import script from "./Certificate.vue?vue&type=script&lang=ts&setup=true"
export * from "./Certificate.vue?vue&type=script&lang=ts&setup=true"

import "./Certificate.vue?vue&type=style&index=0&id=49b78cf7&lang=less&scoped=true"

import exportComponent from "/Users/chengyanbin/Codes/Daming/ksdm_offline/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49b78cf7"]])

export default __exports__